import { createBearingEnvelopeSchema } from './BearingEnvelopeSchema';

export const WallSchema = createBearingEnvelopeSchema('wall', {
  displayName: (wall) => `Wall ${wall.name}`,
  pluralName: 'Walls',
});
